import * as React from 'react';
import { DownloadIcon } from 'lucide-react';
import type { RestrictionEvent } from 'contracts/restricted-products/restricted-products';
import { usePermission } from 'hooks/usePermission';
import { downloadRestrictedEventJustificationFile } from 'utils/fileDownloader';
import { Button } from 'components/ui/button';
import { cn } from 'lib/utils';

type Props = React.ComponentProps<'div'> & {
  justificationFiles: RestrictionEvent['justificationFiles']
}

export const JustificationFiles = ({ justificationFiles, className, ...props }: Props) => {
  const { hasPermissionTo } = usePermission();

  if (!hasPermissionTo(['RES.RESTRICTEDMATERIALS.DOWNLOAD_JUSTIFICATION_FILE'])) {
    return null;
  }

  return (
    <div className={cn('flex flex-col gap-2 text-slate-600', className)} {...props}>
      {justificationFiles?.map((file, index) => (
        <div key={file.id} className={'flex items-center gap-4'}>
          <span className={'truncate'}>{file.fileName}</span>
          <Button size={'sm'} variant={'outline'} className={'ml-auto'}
                  onClick={() => downloadRestrictedEventJustificationFile(file.id)}>
            <DownloadIcon />
          </Button>
        </div>
      ))}
    </div>
  );
};